/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterImageContentAddPost } from '../fn/image-content/api-master-image-content-add-post';
import { ApiMasterImageContentAddPost$Params } from '../fn/image-content/api-master-image-content-add-post';
import { apiMasterImageContentDeleteGet } from '../fn/image-content/api-master-image-content-delete-get';
import { ApiMasterImageContentDeleteGet$Params } from '../fn/image-content/api-master-image-content-delete-get';
import { apiMasterImageContentEditPost } from '../fn/image-content/api-master-image-content-edit-post';
import { ApiMasterImageContentEditPost$Params } from '../fn/image-content/api-master-image-content-edit-post';
import { apiMasterImageContentGetActiveGet } from '../fn/image-content/api-master-image-content-get-active-get';
import { ApiMasterImageContentGetActiveGet$Params } from '../fn/image-content/api-master-image-content-get-active-get';
import { apiMasterImageContentGetAllGet } from '../fn/image-content/api-master-image-content-get-all-get';
import { ApiMasterImageContentGetAllGet$Params } from '../fn/image-content/api-master-image-content-get-all-get';
import { apiMasterImageContentGetByCriteriaPost } from '../fn/image-content/api-master-image-content-get-by-criteria-post';
import { ApiMasterImageContentGetByCriteriaPost$Params } from '../fn/image-content/api-master-image-content-get-by-criteria-post';
import { apiMasterImageContentGetByIdGet } from '../fn/image-content/api-master-image-content-get-by-id-get';
import { ApiMasterImageContentGetByIdGet$Params } from '../fn/image-content/api-master-image-content-get-by-id-get';
import { ImageContent } from '../models/image-content';
import { ImageContentApiRespModel } from '../models/image-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ImageContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterImageContentAddPost()` */
  static readonly ApiMasterImageContentAddPostPath = '/api/Master/ImageContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentAddPost$Response(params?: ApiMasterImageContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContentApiRespModel>> {
    return apiMasterImageContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentAddPost(params?: ApiMasterImageContentAddPost$Params, context?: HttpContext): Observable<ImageContentApiRespModel> {
    return this.apiMasterImageContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageContentApiRespModel>): ImageContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentEditPost()` */
  static readonly ApiMasterImageContentEditPostPath = '/api/Master/ImageContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentEditPost$Response(params?: ApiMasterImageContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContentApiRespModel>> {
    return apiMasterImageContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentEditPost(params?: ApiMasterImageContentEditPost$Params, context?: HttpContext): Observable<ImageContentApiRespModel> {
    return this.apiMasterImageContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageContentApiRespModel>): ImageContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentDeleteGet()` */
  static readonly ApiMasterImageContentDeleteGetPath = '/api/Master/ImageContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentDeleteGet$Response(params?: ApiMasterImageContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterImageContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentDeleteGet(params?: ApiMasterImageContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterImageContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentGetByIdGet()` */
  static readonly ApiMasterImageContentGetByIdGetPath = '/api/Master/ImageContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetByIdGet$Response(params?: ApiMasterImageContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContent>> {
    return apiMasterImageContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetByIdGet(params?: ApiMasterImageContentGetByIdGet$Params, context?: HttpContext): Observable<ImageContent> {
    return this.apiMasterImageContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageContent>): ImageContent => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentGetAllGet()` */
  static readonly ApiMasterImageContentGetAllGetPath = '/api/Master/ImageContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetAllGet$Response(params?: ApiMasterImageContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
    return apiMasterImageContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetAllGet(params?: ApiMasterImageContentGetAllGet$Params, context?: HttpContext): Observable<Array<ImageContent>> {
    return this.apiMasterImageContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ImageContent>>): Array<ImageContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentGetActiveGet()` */
  static readonly ApiMasterImageContentGetActiveGetPath = '/api/Master/ImageContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetActiveGet$Response(params?: ApiMasterImageContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
    return apiMasterImageContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterImageContentGetActiveGet(params?: ApiMasterImageContentGetActiveGet$Params, context?: HttpContext): Observable<Array<ImageContent>> {
    return this.apiMasterImageContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ImageContent>>): Array<ImageContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterImageContentGetByCriteriaPost()` */
  static readonly ApiMasterImageContentGetByCriteriaPostPath = '/api/Master/ImageContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterImageContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentGetByCriteriaPost$Response(params?: ApiMasterImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageContent>>> {
    return apiMasterImageContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterImageContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterImageContentGetByCriteriaPost(params?: ApiMasterImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<ImageContent>> {
    return this.apiMasterImageContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ImageContent>>): Array<ImageContent> => r.body)
    );
  }

}
